import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MoreTestimonials } from './MoreTestimonials';
const plan = {
  name: '📘 THE K-SMART VISUAL SYSTEM™',
  ideal: 'Anyone who wants to understand Korean from zero, without studying languages before',
  was: '$129',
  now: '$27',
  features: ['6 Complete Volumes (120+ pages)', 'Hangul from zero, explained visually', 'Real K-Drama & K-Pop expressions', '30-Day routine with visible progress', '5 Free Bonuses included', '7-Day Money-Back Guarantee'],
  cta: 'Get The K-Smart Visual System'
};
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Access'
}, {
  icon: CreditCardIcon,
  label: 'Credit / Debit'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Pricing" className="bg-radial-glow w-full overflow-x-hidden" data-id="element-130" data-mp="3cae7k3ed75r3">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" data-id="element-131" data-mp="3w1jhw7ys2u1h">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center rounded-3xl border border-grape/30 bg-white px-6 pb-7 pt-10 text-center shadow-[0_24px_60px_-28px_rgba(124,58,237,0.45)]" data-id="element-132" data-mp="4s4bhb4kgrhw">
          <h3 className="font-display text-lg font-black text-plum" data-id="element-133" data-mp="3n7eujyius0qp">{plan.name}</h3>
          <p className="mt-2 text-sm text-plum/60" data-id="element-134" data-mp="3rxv7zimobmd2">
            <span className="font-semibold text-plum/80" data-id="element-135" data-mp="3ryn3yuk6nm3v">Ideal for:</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-136" data-mp="2uhof9m5hist0">
            <span className="text-base font-medium text-plum/40 line-through" style={{
            fontSize: "20px"
          }} data-id="element-137" data-mp="2ugn29c4wrw8n">{plan.was}</span>
            <div className="text-grape-shine font-display text-4xl font-black" style={{
            fontSize: "64px",
            paddingBottom: "26px",
            fontFamily: "Cinzel, serif",
            paddingTop: "20px"
          }} data-id="element-138" data-mp="2rglansogvt93">{plan.now}</div>
            <p className="mt-1 text-xs font-semibold text-grape" data-id="element-139" data-mp="316ej4ktbbs94">
              One-time payment · Lifetime access
            <p className="mt-1 text-[11px] font-medium text-plum/50" data-id="element-140" data-mp="2w71q1ibuloy3">
            Payment will be processed in your local currency.
          </p></p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-141" data-mp="28jtrrkcu7g5k">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-142" data-mp="23l0bxla2vd28">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-143" data-mp="2ihhrkopavdul" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-144" data-mp="3tutxd54me6je">
            <CTAButton size="md" data-id="element-145" data-mp="3txg4x4rigm1m">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[11px] font-semibold text-plum/50" data-id="element-146" data-mp="3ovh0rsny5l3m">
            You save $102 USD (79% OFF)
          </p>
          

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" data-id="element-147" data-mp="cqcnvapzi99">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-148" data-mp="3nhfxpx7wfom6">
                <Icon className="h-4 w-4 text-grape" data-id="element-149" data-mp="3rgyj0u3mu1pj" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <MoreTestimonials data-id="element-150" data-mp="nzye22512760" />

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-grape/20 bg-white/80 p-5 text-left" data-id="element-151" data-mp="o07x15rnne27">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-grape" data-id="element-152" data-mp="a6gx8p3q78jo" />
          <p className="text-[15px] leading-relaxed text-plum/75" data-id="element-153" data-mp="e8u095r38scr">
            <span className="font-display font-bold text-plum" data-id="element-154" data-mp="11z7jq7vlxivq">
              🛡️ 7-Day Money-Back Guarantee.
            </span>{' '}
            If within the first 7 days you feel the ebook does not match what you need or does not
            give you the boost you were looking for, request your refund and we return 100% of your
            money. We want you to learn with peace of mind, risk-free.
          </p>
        </div>
      </div>
    </section>;
}